const humanToFloat = (string) => parseFloat(string.replaceAll(',', '.'))

function updateSpeeds (form) {
  const speeds = {
    flat: humanToFloat(form.flat_speed.value),
    up: humanToFloat(form.up_speed.value),
    down: humanToFloat(form.down_speed.value),
  }


  window.localStorage.setItem('speeds', JSON.stringify(speeds));

  window.displayStats(window.latestResult)

  window.fbq('track', 'CustomizeProduct')
  window.gtag('event', 'select_content', {
    'content_type': "speed",
  });

  return false
}

export default updateSpeeds